import React, { useState } from "react";
import "./CarRentalSection.css";
import hyundai from "../../assets/hyundai.png";
import kia from "../../assets/kia.png";
import toyota from "../../assets/toyota.png";
import honda from "../../assets/honda.png";
import BMW from "../../assets/BMW.png";
import audi from "../../assets/audi.png";
import mercedes from "../../assets/mercedes.png";
import skoda from "../../assets/skoda.png";
import mahindra from "../../assets/mahindra.png";
import nissan from "../../assets/nissan.png";
import { Link } from "react-router-dom"
const CarRentalSection = () => {
  const cars = [
    {
      name: "The Hyundai",
      image: hyundai,
    },
    { name: "The Kia", image: kia },   //
    {
      name: "The Toyota",
      image: toyota,
    },
    {
      name: "The Honda",
      image: honda,   //
    },
    {
      name: "The BMW",
      image: BMW,
    },
    {
      name: "The Audi",
      image: audi,
    },
    {
      name: "The Mercedes",
      image: mercedes,   //
    },
    {
      name: "The Skoda",
      image: skoda,    //
    },
    {
      name: "The Nissan",
      image: nissan,
    },
    {
      name: "The Mahindra",
      image: mahindra,  //
    },
  ];

  const [index, setIndex] = useState(0);
  const [animationClass, setAnimationClass] = useState("");

const nextSlide = () => {
  setAnimationClass("slide-left");

  setTimeout(() => {
    setIndex((prev) => (prev + 1) % cars.length);
    setAnimationClass("");
  }, 300);
};

const prevSlide = () => {
  setAnimationClass("slide-right");

  setTimeout(() => {
    setIndex((prev) => (prev - 1 + cars.length) % cars.length);
    setAnimationClass("");
  }, 300);
};
  return (
    <div className="rental-container">
      <div className="rental-header">
        <h2>
          Rental. <span>Drive.</span> Explore.
        </h2>
     <Link to="/rent-car-view-more"  > <button className="view-btn">View More</button></Link>
      </div>

      <h1 className="car-name">{cars[index].name}</h1>

      <div className={`car-image-wrapper ${animationClass}`}>
        <img src={cars[index].image} alt={cars[index].name} />
      </div>

      <div className="slider-controls">
        <button onClick={prevSlide}>❮</button>
        <button onClick={nextSlide}>❯ </button>
      </div>
    </div>
  );
};

export default CarRentalSection;
